import { memo as Memo } from 'react';

//* Components
import Container from 'components/common/Container';
import Text from 'components/common/Text';
import Image from 'components/common/Image';
import Button from 'components/common/Button';
import FullVideoImage from 'components/common/FullVideoImage';
import DangerDescription from 'components/common/DangerDescription';

//* Styles
import DescriptiveStyle from './style';

const Descriptive = Memo(({ firstSection, secondSection, bgColor, first }) => {
	return (
		<DescriptiveStyle>
			<Container
				first={first}
				section
				full
			>
				<Container className={`first-section-wrap ${secondSection.title || secondSection.description ? '' : 'only-file'} ${secondSection.title || secondSection.description || secondSection.file ? 'has-second-section' : 'no-second-section'}`}>
					<div className='first-section'>
						{firstSection.title && (
							<Text
								tag={first ? 'h1' : 'h2'}
								className={'h3 title font-ping-bolder'}
								text={firstSection.title}
							/>
						)}
						{firstSection.subtitle && (
							<Text
								tag={first && !firstSection.title ? 'h1' : 'h3'}
								className={`h4 subtitle ${!firstSection.title ? 'no-title' : ''} font-ping-regular`}
								text={firstSection.subtitle}
							/>
						)}
						<div className='description-and-image-wrap'>
							<div className={`left-content ${secondSection.title || secondSection.description || secondSection.file ? 'has-second-section' : 'no-second-section'} ${firstSection.link ? 'has-button' : 'no-button'}`}>
								<div
									className={`description`}
									dangerouslySetInnerHTML={{ __html: firstSection.description }}
								/>
								{firstSection.link && (
									<Button
										url={firstSection.link}
										target={'_blank'}
										type={'lottie'}
										text={'learnMore'}
										className='font-ping-regular'
									/>
								)}
							</div>
							<div className={`images-wrap ${secondSection.title || secondSection.description || secondSection.file ? 'has-second-section' : 'no-second-section'} ${firstSection.description ? 'has-description' : 'no-description'}`}>
								<Image
									src={firstSection.smallImg.url}
									objectFit={firstSection.smallImgLandscape ? 'contain' : 'cover'}
									className={`small-img ${firstSection.smallImgLandscape ? 'landscape-image' : ''}`}
									alt={`${firstSection.smallImg.alt}`}
								/>
								<Image
									src={firstSection.bigImg.url}
									objectFit={'cover'}
									className={'big-img'}
									alt={`${firstSection.bigImg.alt}`}
								/>
							</div>
						</div>
					</div>
				</Container>
				{(secondSection.title || secondSection.description || bgColor) && (
					<div className={`bg${bgColor} second-section`}>
						{(secondSection.title || secondSection.description) && (
							<>
								{secondSection.title && (
									<Container
										section
										className={'malibu-end'}
									>
										<Text
											tag={'h4'}
											className={'h3 title font-ping-bolder'}
											text={secondSection.title}
										/>
									</Container>
								)}
								{secondSection.description && <DangerDescription descriptions={secondSection.description} />}
							</>
						)}
					</div>
				)}
				{secondSection.file && (
					<FullVideoImage
						file={secondSection.file}
						alt={secondSection.file.alt}
					/>
				)}
			</Container>
		</DescriptiveStyle>
	);
});

export default Descriptive;
